import { createAction } from 'redux-actions'

export const signin = createAction('SIGNIN')
export const signout = createAction('SIGNOUT')
export const signoutSuccess = createAction('SIGNOUT_SUCCESS')
export const signoutError = createAction('SIGNOUT_ERROR')
export const signinStart = createAction('SIGNIN_START')
export const signinSuccess = createAction('SIGNIN_SUCCESS')
export const signinError = createAction('SIGNIN_ERROR')
export const firebaseSignin = createAction('FIREBASE_SIGNIN')
export const firebaseSignout = createAction('FIREBASE_SIGNOUT')
export const resetRedirectTo = createAction('SIGNIN_RESET_REDIRECT_TO')



// WEBPACK FOOTER //
// ./src/services/signin/actions.js